import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../utils/networkRequests";
import axios from "axios";

const SLICE_NAME = "newsLetterForms";

export const fetchNewsLetterFormFields = createAsyncThunk(
    `${SLICE_NAME}/fetchNewsLetterFormFields`,
    async (link, { getState }) => {
        const state = getState();
        const { countryCode: country, languageCode: lang } = state.auth || {};

        try {
            const response = await axiosInstance.get(link, {
                params: {
                    country,
                    lang,
                },
            });
            return response.data;
        } catch (err) {
            console.error(err);
        }
    },
);

export const saveNewsLetterForm = createAsyncThunk(
    `${SLICE_NAME}/saveNewsLetterForm`,
    async ({ formData }, { getState }) => {
        const state = getState();
        const { submitLink } = state[SLICE_NAME];

        const response = await axios.post(submitLink, formData);
        return response.data;
    },
);

const initialState = {
    formFields: [],
    metaData: {},
    submitLink: "",
    isLoading: false,
};

// Redux Toolkit allows us to write "mutating" logic in reducers. It
// doesn't actually mutate the state because it uses the Immer library,
// which detects changes to a "draft state" and produces a brand new
// immutable state based off those changes
export const newsLetterFormsSlice = createSlice({
    name: SLICE_NAME,
    initialState,
    reducers: {
        // Example reducer:
        // fetchContentAndLayout: (state) => {
        //   const contentKeysMappedToLowercase = {}
        //   Object.keys(contentFromII.content).forEach(
        //     (k) => (contentKeysMappedToLowercase[k.toLowerCase()] = contentFromII.content[k]),
        //   )
        //   state.content = contentKeysMappedToLowercase
        //   state.layout = layoutFromII.layout
        // },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNewsLetterFormFields.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchNewsLetterFormFields.fulfilled, (state, action) => {
                const data = action.payload;
                const { fields, submit_link: submitLink, ...meta } = data;
                state.formFields = fields;
                state.submitLink = submitLink;
                state.metaData = meta;
                state.isLoading = false;
            })
            .addCase(fetchNewsLetterFormFields.rejected, (state) => {
                state.isLoading = false;
            });
    },
});

export default newsLetterFormsSlice.reducer;
